import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SampleObj } from '../../models/models';

@Component({
  selector: 'app-lab-sample-modal',
  templateUrl: './lab-sample-modal.component.html',
  styleUrls: ['./lab-sample-modal.component.css']
})
export class LabSampleModalComponent implements OnInit {

  @Input() selectedSample:SampleObj;
  @Output() addTestPopupEvent = new EventEmitter<any>();
  constructor() {
    this.selectedSample = this.resetSelectedSample();
 }

  resetSelectedSample=():SampleObj=>{
    const sample:SampleObj = {
      sampleId:'',
      status:'',
      flag:false,
      daughterFlag:false,
      sampleType:'',
      filterFlag:false,
      dateOfCollection:''
    }
    return sample;
  }

  ngOnInit(): void {
  }

  addTestPopup(item:any){
    this.addTestPopupEvent.emit(item);
  }

}
